import { useMediaQuery } from "react-responsive";
import breakpoints from "@silversea-ssc/design-system-tokens/dist/definitions/breakpoints.json";

type BreakpointCode = keyof typeof breakpoints;

const breakpointValue = (code: BreakpointCode): string => breakpoints[code];

export const useIsTabletOrDesktop = (): boolean => {
  return useMediaQuery({ minWidth: breakpointValue("md") });
};

export const useIsDesktop = (): boolean => {
  return useMediaQuery({ minWidth: breakpointValue("lg") });
};
